module.exports = __webpack_public_path__ + "static/media/logbook.4b9e7933.png";